import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';


//icons
// import Icon from '@material-ui/core/Icon';
// import TrendingDown from '@material-ui/icons/TrendingDown';
// import TrendingUp from '@material-ui/icons/TrendingUp';
// import ArrowUpward from '@material-ui/icons/ArrowUpward';
// import ArrowDownward from '@material-ui/icons/ArrowDownward';



//color
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';

//
import Chart from './Chart'

// util
import { truncate } from '../utils/truncate'



const useStyles = makeStyles(theme => ({
    card: {
        // minWidth: 275,
        textAlign: "center",
        margin: 0,
        padding: 0,

    },
    cardContent: {
        margin: 0,
        padding: 0,
    },
    title: {
        fontSize: 14,
        textAlign: "left",
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2)
    },
    pos: props => ({
        marginBottom: 12,
        color: props.color
    }),
    iconPos: {
        marginRight: theme.spacing(1),
        paddingTop: theme.spacing(1)
    },
    iconMoeda: {
        margin: 10,
        width: 60,
        height: 60,
        textAlign: 'center'
    },
    chart: {
        height: 40,
        margin: 10,
    },
    circulo: {
        float: 'right',
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        margin: '15px',
        transition: '0.3s ease',
        backgroundColor: green[500],
        position: 'absolute'
    }
}));

export default function MoedaCard({ coin, base, market, volume, fiat, onClick, isBase }) {

    // console.log('isBase: ', isBase);

    const props = market ? { color: coin.change > 0 ? green[500] : red[500] } : { color: red[500] }



    const classes = useStyles(props);
    // const bull = <span className={classes.bullet}>•</span>;

    return (

        <Card className={classes.card}>
            <>
                {
                    !isBase || <div className={classes.circulo}></div>
                }
            </>

            <ButtonBase
                focusRipple
                style={{
                    margin: 0,
                    padding: 0,
                    width: '100%',
                    height: '100%'
                }}
                onClick={onClick}
            >

                <CardContent className={classes.cardContent}>
                    {
                        market &&
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            #{coin.rank}
                        </Typography>
                    }

                    <img alt={'Simbolo' + coin.name} src={coin.iconUrl} className={classes.iconMoeda} />


                    <Typography>
                        {coin.name}
                    </Typography>

                    {
                        market ||
                        <Typography variant="h6">
                            {
                                volume !== 0 ?
                                    fiat ?
                                        truncate(parseFloat(volume).toLocaleString('pt-BR', { style: "decimal", minimumFractionDigits: 2, maximumFractionDigits: 2 }), 13)
                                        :
                                        truncate(parseFloat(volume).toLocaleString('pt-BR', { style: "decimal", maximumFractionDigits: 8 }), 13)
                                    :
                                    'Digite'
                            }
                        </Typography>
                    }



                    {
                        market &&
                        <>
                            <Typography variant="h6">
                                {base.sign} {coin.price < 1 ? parseFloat(coin.price).toFixed(4) : parseFloat(coin.price).toFixed(2)}
                            </Typography>


                            <Typography className={classes.pos}>
                                {
                                    coin.change > 0 ?
                                        <>
                                            {/* <TrendingUp className={classes.iconPos} /> */}
                                            {/* <ArrowUpward className={classes.iconPos} /> */}
                                            + {coin.change}
                                        </>
                                        :
                                        <>
                                            {/* <TrendingDown className={classes.iconPos} /> */}
                                            {/* <ArrowDownward className={classes.iconPos} /> */}
                                            - {coin.change * -1}
                                        </>
                                } %
                            </Typography>
                            <div className={classes.chart}>
                                <Chart history={coin.history} colorLine={coin.change > 0 ? green[500] : red[500]} />
                            </div>
                        </>
                    }

                </CardContent>
                {/* <CardActions>
                <Button size="small">Learn More</Button>
            </CardActions> */}
            </ButtonBase>

        </Card >
    );
}